/**
 * Generated with @muse/import-icons
 * Do not edit directly
 */

import { createIcon } from '../lib/create-icon';

export const AcousticGuitarIcon = createIcon(
  '0 0 20 20',
  <path d="m12 4 2-1v12a1.5 1.5 0 0 0-1.5 1.5V18h-5v-1.5A1.5 1.5 0 0 0 6 15V3l2 1 2-1zm3 3a1 1 0 1 1 2 0 1 1 0 0 1-2 0m1 2a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-1 4a1 1 0 1 1 2 0 1 1 0 0 1-2 0M4 12a1 1 0 1 1 0 2 1 1 0 0 1 0-2m0-3a1 1 0 1 1 0 2 1 1 0 0 1 0-2m0-3a1 1 0 1 1 0 2 1 1 0 0 1 0-2" />,
);
